import ICONS from "../../../assets/Icons";
import TEXT from "../../../utils/globalText";
import SVGComponent from "../../_utils/SVGComponent";
import AdditionalDetailsPreviewMapper from "../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import ConfidentialCard from "../../_utils/TransactionCommonComponents/ConfidentialCard";
import PaymentMethodSelector from "../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import InternalTransactionViewAll from "../../../containers/InternalTransactionMain/InternalTransactionViewAll";
import CommonLayout from "../../_utils/CommonLayout";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const InternalTxnConfirm = (props) => {
  const allLabels = [
    ...new Set([
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerlabels || []),
    ]),
  ];

  return (
    <>
      {props?.showSimilarModal && (
        <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Similar transactions found"
            isHeaderImgNeed={true}
            ShowIcon={ICONS.ALERT}
            headersubtext="Transactions with similar details have already been created. Proceeding will result in a duplicate transaction."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => props?.setShowSimilarModal(false)}
            closeicon={
              "https://q2pay.in/new_assets/common/create_flow/close.svg"
            }
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            confirmbtnrequired={true}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            isbottomSectionneed={true}
            bottomHeaderTextNeed={true}
            btnText="Proceed with caution"
            handleFunction={() => {
              props?.setShowSimilarModal(false);
              props?.onForceCreate();
            }}
            bottomHeaderText={"Proceed with creating this transaction?"}
          >
            <InternalTransactionViewAll
              onClose={() => props?.setShowSimilarModal(false)}
              txnHistorytype={"internalCreateTxn"}
              duplicateFilters={props?.buildDuplicateCheckPayload}
              internal_account_bank_acc_no={props?.txnPayLoad?.bankAccountNo}
              bank_acc_no={props?.txnPayLoad?.ownerBankAccountNo}
              txnPayLoad={props?.txnPayLoad}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div
        className={`w-width-full Qlg:px-padding-base px-padding-md py-padding-md  max-w-tab-width-normal mx-auto`}
      >
        <CommonLayout>
          <SourceDestinationAccountDetail
            type="source"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />

          <SourceDestinationAccountDetail
            type="destination"
            flow="internal"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />

          <div className="flex flex-col w-full gap-y-gap-md">
            <Amount
              isPreview={true}
              txnPayLoad={props?.txnPayLoad}
            />
            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={props?.txnPayLoad?.settleType}
            />
          </div>

          <ConfidentialCard
            icon={ICONS?.CONFIDENTIAL_TRANSACTION}
            title={TEXT?.CREATE_AS_CONFIDENTIAL}
            note={TEXT?.CONFIDENTIAL_TRANSACTION_NOTE}
            toggleState={props?.isConfidential}
            isPreview={true}
          />

          <div className="lg:max-w-[var(--create-box-width)] w-width-full">
            <AdditionalDetailsPreviewMapper
              mappingData={props.txnPayLoad.mergeCategory}
              previewImages={props?.previewImages}
            />
          </div>

          <div className="w-width-full h-auto p-padding-md rounded-border-radius-md bg-primary-card">
            <p className="text-left text-base mb-margin-md text-text-primary">
              <span className="font-semibold">Labels</span>
              <span className="font-normal"> (Optional)</span>
            </p>

            <p className="text-text-primary text-font-sm break-words lg:break-normal lg:whitespace-normal">
              {allLabels.length === GlobalConfiguration?.lengthCheckZero ? (
                <span>{TEXT?.NO_LABELS_ASSIGNED}</span>
              ) : (
                allLabels.map((item, index) => (
                  <span key={index}>
                    {item}
                    {index <
                      allLabels.length - GlobalConfiguration?.lengthCheckOne &&
                      ", "}
                  </span>
                ))
              )}
            </p>

            <p className="text-text-secondary text-font-xs font-normal">
              {TEXT?.LABELS}
            </p>
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default InternalTxnConfirm;
